import { render, staticRenderFns } from "./SimilarSearch.vue?vue&type=template&id=bf330578&scoped=true&"
import script from "./SimilarSearch.vue?vue&type=script&lang=js&"
export * from "./SimilarSearch.vue?vue&type=script&lang=js&"
import style0 from "./SimilarSearch.vue?vue&type=style&index=0&id=bf330578&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf330578",
  null
  
)

export default component.exports